import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Alert,
  ModalFooter,
} from "reactstrap";
import { Growl } from "primereact/growl";
import { Textbox, Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import Select1 from 'react-select';
import { withRouter } from "react-router-dom";
import publicIp from "public-ip";
import { connect } from "react-redux";
import makeAnimated from "react-select/lib/animated";
import {
  consultarCedulaFetch,
  setConsultaPlaca,
  setDatosPersona,
  coberturasFetch,
  AmparosAdicionalesFetch,
  FetchDescargarCotizacionAbierto,
} from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import {
  FetchModificarCarrito,
  FetchGuardarDatosAdiconalesCarrito,
  FetchTotalesCabeceraCotizadores,
} from "../../redux/actions/ACarritoProductos";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import "react-datepicker/dist/react-datepicker.css";

import { ambienteAplicacion, urlGenerarPago, urlGetRecompraConfirmacion } from "../../constants/urls";
import ValoresRecompra from "../Cotizacion/ValoresRecompra";
import { FetchDataRecompraPaquete } from "../../redux/actions/APolizas";
import { apiGet, apiPost2 } from "../../api";
import { tramaSuscripcionTarjetaP2P } from "../../constants/tramas/tramasPago";
import { suscripcionExternaTarjetaP2P } from "../../redux/actions/aPagos";
import { consultarUsuarioFV } from "../../redux/actions/aFormularioVinculacion";
import NumberFormat from 'react-number-format';

class ReCompra extends React.Component {
  constructor(props) {
    super(props);

    const { datosRecompra } = this.props;

    console.log('mis props: ', this.props)
    this.state = {
      placa: datosRecompra.placa,
      validate: false,
      hasPlacaError: true,
      rastreo: false,
      territorioSeleccionado: "1",
      formEditado: false,
      isLoading: false,
      sumaAseguradaHasError: false,
      valorAsegurado: datosRecompra.sumaAsegurada,
      arrayTerritorios: [],
      accesoriosHabilitado: false,
      valorAccesorios: datosRecompra.datosAccesorios.valorAccesorios,
      arrayAccesorios: [],
      arrayColores: [],
      hasValorAccesoriosError: false,
      cedulaError: "",
      hasColorError: false,
      hasMotorError: true,
      hasChasisError: true,
      arrayTipos: [],
      tipoSeleccionado: null,
      hasTipoError: false,
      contadorCoberturas: 0,
      amparoGastosMedicosCheked: true,
      amparoAccidentesPersonalesCheked: true,
      amparoAutoSustitutoCheked: true,
      amparoLlaveProtegidaCheked: true,
      amparoDocumentosProtegidosCheked: true,
      hasCapacidadError: true,
      deducibleSelected: null,
      arrayRc: [],
      rcSelected: null,
      verDeducibles: false,
      verRc: false,
      mostrarMensajeValidarEdad: false,

      codigoProductoEspecial: null,
      planes: [],
      planSeleccionado: datosRecompra.arrayPlanes.find(plan => plan.codigo == datosRecompra.planActual),
      utilizarMismaTarjeta: false,
      cuotas: 1,
      cuotaSeleccionada: {
        value: 1,
        label: '1 mes (Pago corriente)'
      },
      bancoSeleccionado: listSlct1(this.props.datosBancos)[0],
      codigoBanco: listSlct1(this.props.datosBancos)[0].value,
      arrayCuotas: this.listSlct1Cuotas(this.props.datosBancos[0].cuotas, datosRecompra.arrayPlanes.find(plan => plan.codigo == datosRecompra.planActual)),
      openModal: false,
      datosPagador: null,
      idPoliza: null,
      idCarrito: null,
      completo: false,
      selectedOption: datosRecompra.datosAccesorios.accesorios,
      email: '',
      tieneError: false,
      mensajeError: '',
      errorSumaAsegurada: '',
    };
    this.validateForm = this.validateForm.bind(this);


  }

  async componentDidMount() {
    window.scrollTo(0, 0);




  

    let arrayAccesorios = [];

    this.props.catalogoCotizacion.accesorios.forEach((element) => {
      const elemento = {
        value: element.accCodigoCore,
        label: element.accNombre,
      };
      arrayAccesorios.push(elemento);
    });

  
    this.setState({ arrayAccesorios: arrayAccesorios });



  }
  /**
   * 
   * @param {*} valor Valor seleccionado en el dropdown bancos
   * Acción al seleccionar un banco
   */
  handleChangeBanco = (valor) => {
    const { datosBancos } = this.props;
    const diferidos = datosBancos.find(banco => banco.id == valor.value).cuotas

    this.setState({
      bancoSeleccionado: valor,
      cuotaSeleccionada: this.listSlct1Cuotas(diferidos, this.state.planSeleccionado)[0],
      cuotas: 1,
      codigoBanco: valor.value,
      arrayCuotas: this.listSlct1Cuotas(diferidos, this.state.planSeleccionado),
    })
  }

  async onEnviar(event, email, url, idCarrito) {



    if (email != "") {
      event.preventDefault()
      let datosJson = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        accion: "enviar",
        correo: email,
        idCarrito: idCarrito,
        url: url
      }

      await this.props.descargarCotizacion(datosJson)
    }



  }


  /**
   * 
   * @param {*} valor valor seleccionado en el dropdown cuotas
   * Acción al seleccionar un elemento en el dropdown de cuptas
   */
  handleChangeCuotas = (valor) => {
    this.setState({
      cuotaSeleccionada: valor,
      cuotas: parseInt(valor.value),
    })
  }

  openModal = (value) => {
    this.setState({ openModal: value });
  };
  suscripcion = (datosPagador, data) => {
    this.SuscripcionTarjetaP2P(datosPagador, data.idPoliza)
  }
  showWarn = (message, severity) => {
    this.growl.show({
      sticky: true,
      severity: severity,
      summary: "Información",
      detail: message,
    });
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption });


  };

  handleChangeColores = (selectedOptionColores) => {
    this.setState({ selectedOptionColores });
    this.setState({ hasColorError: false });


  };



  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError,
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }


  onSelect = (value) => {

    if (value) {
      this.setState({
        planSeleccionado: value,
        formEditado: true,
      });
    }


  };


  /**
   * 
   * @param {*} list lista inicial
   * @returns  Lista formateada para utilizar en Select1
   */
  listSlct1Cuotas = (list, planSeleccionado) => {

    const numeroMeses = planSeleccionado.vigenciaMeses.split(' ')[0];


    const formatList = []

    list.forEach(element => {

      if (element <= numeroMeses) {
        formatList.push({
          value: element,
          label: element == 1 ? '1 mes (Pago corriente)' : element + ' meses'
        })
      }

    });


    // return
    return formatList
  }

  onEditarPlaca = (e) => {
    this.props.history.push({
      pathname: "/cotizacion",
      search: `?accion=editarPlaca&editarPlaca=true`

    });
  }

  onClickContinuar = async (e) => {


    if (
      this.state.valorAsegurado != "" && 
      this.state.valorAsegurado != undefined && 
      this.state.valorAsegurado > 0 &&
      this.state.hasValorAccesoriosError == false &&
      (this.state.accesoriosHabilitado == false || (this.state.accesoriosHabilitado == true && this.state.selectedOption.length>0))
      
      ) {

      this.setState({
        isLoading: true,
      })

      let datosAccesorios = {
        "datosAccesorios": {
          "accesorios": this.state.selectedOption,
          "valorAccesorios": this.state.valorAccesorios
        }
      }


      const data = await apiPost2(`${urlGetRecompraConfirmacion}${this.props.idPoliza}&plan=${this.state.planSeleccionado.codigo}&sumaAsegurada=${this.state.valorAsegurado}&cuotas=${this.state.cuotas}&codigoBanco=${this.state.codigoBanco}`, datosAccesorios)

      if (data.transaccion) {



        this.setState({ completo: true })

        const datosPagador = data.datosPagador;



        if (!this.state.utilizarMismaTarjeta || !data.pedirSuscripcion) {

          this.setState({ datosPagador: datosPagador, idPoliza: data.idPoliza, idCarrito: data.idCarrito })

          setTimeout(() => {
            this.irAFormularioVinculacion(data.idCarrito)
          }, 300);





        } else {

          this.irAFormularioVinculacion(data.idCarrito)

        }



      }

      this.setState({
        isLoading: false,
      })

    }




  }

  irAFormularioVinculacion = async (idCarrito) => {
    this.props.history.push({
      pathname: "/forma-pago",
      search: `?id=${idCarrito}`,
    });
  }

  // suscribir tarjeta p2p
  async SuscripcionTarjetaP2P(pagador, idPoliza) {


    const nombre = pagador.cliNombre1;
    const apellido = pagador.cliApellido1;
    const email = pagador.cliEmail;
    const identificacion = pagador.cliIdentificacion;
    const tipoDocumento = pagador.cliCodigoTipoDocumento === 'CÉDULA' ? 'CI' : (pagador.cliCodigoTipoDocumento === 'RUC' ? 'RUC' : 'PAS');
    const celular = pagador.cliCelular;
    let cliIp = '';
    await publicIp.v4().then(
      ip => cliIp = ip
    );

    // body post
    const body = tramaSuscripcionTarjetaP2P({
      idPoliza, nombre, apellido, email, identificacion, tipoDocumento, celular, cliIp
    });



    // consultar servicio para redireccion
    await this.props.suscripcionP2P(body);
    window.location.href = this.props.placetoPay.suscripcionTarjetaP2PResponse.traUrl;

  }


  onClickActualizar = async (e) => {

    if (
      this.state.valorAsegurado != "" && 
      this.state.valorAsegurado != undefined && 
      this.state.valorAsegurado > 0 &&
      this.state.hasValorAccesoriosError == false &&
      (this.state.accesoriosHabilitado == false || (this.state.accesoriosHabilitado == true && this.state.selectedOption.length>0))
      
      ) {

        let datosAccesorios = {
          "datosAccesorios": {
            "accesorios": this.state.selectedOption,
            "valorAccesorios": this.state.valorAccesorios
          }
        }

      await this.props.listarRecompra(this.props.idPoliza, this.state.planSeleccionado.codigo, this.state.valorAsegurado, datosAccesorios)

      this.handleChangeBanco(this.state.bancoSeleccionado)

      this.setState({
        formEditado: false,
      });

    }

  }

  render() {
    const {
      validate,
      placa,
      rastreo,
      utilizarMismaTarjeta,
      formEditado,
      valorAsegurado,
      deducibleSelected,
      arrayRc,
      rcSelected,
      verDeducibles,
      verRc,
    } = this.state;



    const { datosRecompra, datosBancos } = this.props;





    return (
      <LoadingScreen

        loading={this.state.isLoading || this.props.formularioVinculacion.usuarioFvLoading}

        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.state.isLoading ? "Guardando información..." : "Obteniendo información..."}
      >


        <Row>
          <Col
            lg={8}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >
            <Card className="flex-row">
              <CardBody>
         
                <h4 style={{ fontWeight: "bold" }}> Datos del Vehículo</h4>
                <p />
                <Row>
                  <Col lg={3} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Marca</h5>
                  </Col>
                  <Col lg={3} md={6} sm={6} xs={12}>
                  
                    <Textbox
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="test"
                      name="test"
                      classNameInput={
                        "input-type-label form-control"
                      }
                      value={datosRecompra.marca}
                    />
                  </Col>
                  <Col lg={3} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Año</h5>
                  </Col>
                  <Col lg={3} md={6} sm={6} xs={12}>
                    <Textbox
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="test"
                      name="test"
                      classNameInput={

                        "input-type-label form-control"
                      }
                      value={datosRecompra.anio}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Modelo</h5>
                  </Col>
                  <Col lg={9} md={6} sm={6} xs={12}>
                    <Textbox
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="test"
                      name="test"
                      classNameInput={
                        "input-type-label form-control"
                      }
                      value={datosRecompra.modelo}
                    />
                  </Col>
                </Row>




                <Row>


                  <Col lg={3} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Placa</h5>
                  </Col>
                  <Col lg={3} md={6} sm={6} xs={12}>
                    {datosRecompra.placa !== "" &&
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={

                          "input-type-label form-control"
                        }
                        value={datosRecompra.placa}
                      />
                    }

                    {datosRecompra.placa === "" &&
                      <Button
                        className="btn btn-purple"
                        onClick={this.onEditarPlaca}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        <i className="fa fa-plus-circle" aria-hidden="true" /> INGRESAR PLACA
                      </Button>

                    }
                  </Col>
                </Row>
                <Row>


                  <Col lg={3} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Suma asegurada</h5>
                  </Col>
                  <Col lg={3} md={6} sm={6} xs={12}>
                    <NumberFormat
                      className="form-control"
                      disabled={false}
                      value={valorAsegurado}
                      thousandSeparator={','}
                      decimalSeparator={'.'}
                      decimalScale={2}
                      id="valorasegurado"
                      name="valorasegurado"

                      prefix={''}
                      onValueChange={(valorAsegurado, e) => {

                        console.log(this.props.limitesVehiculos)

                        if (
                          this.props.limitesVehiculos !== undefined &&
                          this.props.limitesVehiculos.limAvaluo !== undefined &&
                          this.props.limitesVehiculos.limAvaluo.valMax !== undefined &&
                          this.props.limitesVehiculos.limAvaluo.valMin !== undefined
                        ){

                          if(this.props.limitesVehiculos.limAvaluo.valMax < valorAsegurado.floatValue){
                            this.setState({
                              errorSumaAsegurada: `El valor ingresado debe ser menor a $ ${this.props.limitesVehiculos.limAvaluo.valMax}`,
                              valorAsegurado: valorAsegurado.floatValue,
                              formEditado: false,
                              })
                            
                            return;
                          }
                          if (this.props.limitesVehiculos.limAvaluo.valMin > valorAsegurado.floatValue){
                            this.setState({
                              errorSumaAsegurada: `El valor ingresado debe ser mayor a $ ${this.props.limitesVehiculos.limAvaluo.valMin}`,
                              valorAsegurado: valorAsegurado.floatValue,
                              formEditado: false,
                            })
                            return;
                          }

                          this.setState({errorSumaAsegurada: '',valorAsegurado: valorAsegurado.floatValue, formEditado: true,})
                          
                            
                        }



                       

      

                      }}
                      onBlur={(e) => {
                        this.setState({ blur: true });
                        //console.log("BLUUUR");
                      }}
                      
                      
                    />
                      {
                        this.state.errorSumaAsegurada !== '' ?
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          {this.state.errorSumaAsegurada}
                        </span> : null
                      }
                          
                  </Col>

                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Alert color="warning">


                      {
                        datosRecompra.alertaSuma
                      }


                    </Alert>
                  </Col>
                </Row>

                


                <Row>
                  <Col lg={3} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Color</h5>
                  </Col>
                  <Col lg={4} md={6} sm={6} xs={12}>
                    <Textbox
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="test"
                      name="test"
                      classNameInput={
                        "input-type-label form-control"
                      }
                      value={datosRecompra.color}
                    />
                  </Col>
                </Row>

                <Row>
                    <Col lg={5} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>
                        {" "}
                        ¿El Vehículo posee Accesorios Adicionales?{" "}
                      </h5>
                      <p />
                    </Col>
                    <Col lg={1} md={6} sm={6} xs={12}>
                      <Checkbox
                        id={"accesorios"} // Optional.[String].Default: "".  Input ID.
                        name={"accesorios"} // Optional.[String].Default: "". Input name
                        classNameInputBox={'check-uber'}
                        customStyleInputBox={{
                          backgroundColor:this.state.accesoriosHabilitado ?'#001871': '#FFFFFF',
                          width: 20,
                          height: 20,
                        }}
                        //value={accesoriosHabilitado} // Required.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        checked={this.state.accesoriosHabilitado} // Required.[Bool].Default: false.
                        onChange={(accesoriosHabilitado, e) => {
                          this.setState({
                            accesoriosHabilitado,
                            formEditado: true,
                          });
                          //console.log(e);
                        }} // Required.[Func].Default: () => {}. Will return the value.
                        validationOption={{
                          name: "accesorios", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                  </Row>

                  {this.state.accesoriosHabilitado  && this.state.arrayAccesorios.length>0  && (
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        
                        <Select1
                          value={this.state.selectedOption}
                          onChange={this.handleChange}
                          options={this.state.arrayAccesorios}
                          isSearchable={true}
                          placeholder={
                            "Seleccione los accesorios extra que posee su vehiculo. Ej: Radio"
                          }
                          isMulti={true}
                        />
                        {(this.state.selectedOption === null ||
                          this.state.selectedOption.length === 0) && (
                            <span style={{ color: "red", fontSize: "1rem" }}>
                              Por favor ingrese al menos un accesorio
                            </span>
                          )}
                      </Col>
                      <Col lg={3} md={3} sm={3} xs={3}>
                        <h5 style={{ fontWeight: "bold" }}>Valor accesorios</h5>
                      </Col>
                      <Col lg={3} md={3} sm={3} xs={3}>



                        {this.props.datosCotizacion && datosRecompra.porcentajeExtras &&
                          <Textbox
                            ref={this.textInput}
                            tabIndex="1"
                            validate={validate}
                            type="text"
                            id="test"
                            name="test"
                            classNameInput="form-control"
                            placeholder="Ingrese valor ejemplo ($ 120.50)"
                            value={this.state.valorAccesorios}
                            onChange={(valorAccesorios, e) => {
                              this.setState({
                                valorAccesorios,
                                formEditado: true,
                              });
                              //console.log(e);
                            }}
                            validationCallback={(res) =>
                              //console.log(res)
                              this.setState({
                                hasValorAccesoriosError: res,
                                validate: false,
                              })
                            }
                            onBlur={(e) => {
                              this.setState({ blur: true });
                              //console.log("BLUUUR");
                            }}
                            validationOption={{
                              name: "Valor accesorios", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: false,
                              customFunc: (res) => {
                                //Optional.[Func].Default: none. Custom function. Returns true or err message
                                let valorExtras =
                                  (valorAsegurado *
                                    datosRecompra.porcentajeExtras) /
                                  100;
                                if (this.state.valorAccesorios < 0) {
                                  return "El valor ingresado debe ser positivo";
                                } else if (this.state.valorAccesorios > valorExtras) {
                                  return `El valor ingresado debe ser menor a $ ${valorExtras}`;
                                } else if (res === "0") {
                                  //console.log("Validando: ", res)
                                  return "El valor ingresado debe ser mayor a 0";
                                } else if (res === "") {
                                  return "Debe ingresar un valor numérico";
                                }

                                return true;
                              },
                            }}
                          />

                        }



                      </Col>
                    </Row>
                  )}





              </CardBody>
            </Card>




          </Col>

          <Col
            lg={4}
            md={12}
            sm={12}
            xs={12}
            className="detalle-impuestos-box"
          >
            <Growl ref={(el) => (this.growl = el)} style={{ top: "100px" }} />
            <Modal
              isOpen={this.state.openModal && this.state.datosPagador && this.state.idPoliza && this.state.idCarrito}
              toggle={() => this.openModal(false)}
            >
              <ModalHeader toggle={() => this.openModal(false)}>
                Seleccione una opción
              </ModalHeader>
              <ModalBody>
                <div className="text-center">

                  <Button
                    onClick={(evt) => {


                      this.SuscripcionTarjetaP2P(this.state.datosPagador, this.state.idPoliza)
                      this.openModal(false)
                      this.setState({ loadign: true });
                    }
                    }
                  >
                    <i
                      className="fa fa-credit-card"
                      aria-hidden="true"
                    />{" "}
                    Pago con tarjeta
                  </Button>

                  <Button
                    style={{ marginLeft: 10 }}
                    onClick={async (evt) => {

                      this.setState({ loadign: true, openModal: false })

                      var url = `${urlGenerarPago}${this.state.idPoliza}`;

                      await fetch(url, {
                        method: "get",
                        headers: {
                          Accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((data) => {

                          this.setState({ loadign: false })



                          if (data.transaccion) {
                            this.showWarn(data.alerta, 'info')

                            setTimeout(() => {
                              this.irAFormularioVinculacion(this.state.idCarrito)

                            }, 2000);

                          } else {
                            this.showWarn(data.alerta, 'warn')

                          }



                        })
                        .catch((response) => {
                          console.log('error')
                          this.setState({ loadign: false, errorEnvio: true })
                        });



                    }


                    }
                  >
                    <i
                      className="fa fa-envelope"
                      aria-hidden="true"
                    />{" "}
                    {'Enviar correo al cliente'}
                  </Button>

                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => this.openModal(false)}>
                  Cerrar
                </Button>
              </ModalFooter>
            </Modal>
            <ValoresRecompra
              key={1}
              formEditado={formEditado}
              recompra={true}
              paso={"datos-cotizacion"}
              metodo={this.onClick}
              placa={placa}
              urlPdf={datosRecompra.urlPdfCotizacion}
              completo={this.state.completo}
              planes={datosRecompra.arrayPlanes}
              totales={datosRecompra.valorTotal}
              email={this.state.email}
              metodoEnviar={(event) => this.onEnviar(event, this.state.email, datosRecompra.urlPdfCotizacion, datosRecompra.idCarrito)}
              setEmail={(email) => { this.setState({ email: email }) }}
              planSeleccionado={this.state.planSeleccionado}
              codigoProductoEspecial={
                this.state.codigoProductoEspecial != null ? true : false
              }
              openModal={() => this.openModal(true)}
              codeProductoEspecial={this.state.codigoProductoEspecial}
              onContinuar={this.onClickContinuar}
              onActualizar={this.onClickActualizar}
              onSelect={this.onSelect}
              disabled={this.state.errorSumaAsegurada !== '' ? true : false}
            />
          </Col>
        </Row>

        {!datosRecompra.tipoTarjeta == "" && true == false && <Row>
          <Col
            lg={8}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >

            <Card className="flex-row">
              <CardBody>
                <h4 style={{ fontWeight: "bold" }}> Detalles</h4>
                <p />

                <Row>
                  <Col lg={5} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>
                      {`¿Desea utilizar la tarjeta que termina en ${datosRecompra.ultimosDigitos}?`}
                    </h5>
                  </Col>
                  <Col lg={1} md={6} sm={6} xs={12}>
                    <Checkbox
                      id={"agreement"} // Optional.[String].Default: "".  Input ID.
                      name={"agreement"} // Optional.[String].Default: "". Input name
                      value={this.state.utilizarMismaTarjeta} // Required.[String].Default: "".
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      checked={utilizarMismaTarjeta} // Required.[Bool].Default: false.
                      onChange={(utilizarMismaTarjeta, e) => {
                        console.log(rastreo)
                        this.setState({
                          utilizarMismaTarjeta,

                        });
                        //console.log(e);
                      }} // Required.[Func].Default: () => {}. Will return the value.
                      validationOption={{
                        name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}
                    />
                  </Col>


                </Row>


              </CardBody>

            </Card>

          </Col>
        </Row>}

        {this.state.planSeleccionado && !this.state.isLoading && true == false && <Row>
          <Col
            lg={8}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >

            <Card className="flex-row">
              <CardBody>
                <h4 style={{ fontWeight: "bold" }}>Diferido</h4>
                <p />

                <Row>


                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Seleccione el banco emisor de su tarjeta</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Select1
                      options={listSlct1(datosBancos)}
                      value={this.state.bancoSeleccionado}

                      onChange={
                        (value, e) => {
                          this.handleChangeBanco(value)
                        }
                      }


                    />
                  </Col>
                </Row>

                <Row>


                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Seleccione los meses a diferir</h5>

                    {this.state.arrayCuotas.length == 1 &&
                      <Alert color="warning">

                        <strong>
                          {
                            "Su banco permite el pago únicamente en corriente"
                          }
                        </strong>

                      </Alert>
                    }

                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Select1
                      value={this.state.cuotaSeleccionada}
                      options={this.state.arrayCuotas}
                      searchable={false}
                      onChange={
                        (value, e) => {
                          this.handleChangeCuotas(value)
                        }
                      }
                    />
                  </Col>
                </Row>


              </CardBody>

            </Card>

            <div style={{ height: 200 }}></div>

          </Col>
        </Row>}



      </LoadingScreen>
    );
  }
}

/**
 * 
 * @param {*} list lista inicial
 * @returns  Lista formateada para utilizar en Select1
 */
const listSlct1 = (list) => {
  console.log('list', list)
  const formatList = []
  for (const idx in list) {

    formatList.push({
      value: list[idx]['id'],
      label: list[idx]['nombre']
    })
  }

  // return
  return formatList
}



const mapStateToProps = (state) => ({
  catalogoCotizacion: state.catalogosCotizacion,
  dataProductoCarrito: state.dataProductoCarrito,
  datosCotizacion: state.datosCotizacion,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosSucursales: state.datosSucursales,
  datosCoberturas: state.catalogosCotizacion.coberturas,
  datosAmparos: state.catalogosCotizacion.amparosAdicionales,
  deduciblesRolesDatos: state.deduciblesRolesDatos,
  limitesVehiculos: state.dataParametros,
  placetoPay: state.rPlaceToPay,
  formularioVinculacion: state.rFormularioVinculacion,
});

const mapDispatchToProps = (dispatch) => {
  return {
    consultarCedula: (cedula, esAsegurado) => dispatch(consultarCedulaFetch(cedula, esAsegurado)),
    setDatosPlaca: (datos) => dispatch(setConsultaPlaca(datos)),
    descargarCotizacion: (datos) => dispatch(FetchDescargarCotizacionAbierto(datos)),
    modificarCarrito: (datos) => dispatch(FetchModificarCarrito(datos)),
    setDatosPersona: (datos) => dispatch(setDatosPersona(datos)),
    fetchGuardarDatosAdiconalesCarrito: (datos, array) =>
      dispatch(FetchGuardarDatosAdiconalesCarrito(datos, array)),
    listarCoberturas: (territorio) => dispatch(coberturasFetch(territorio)),
    listarAmparosAdicionales: (territorio, codEspecial) =>
      dispatch(AmparosAdicionalesFetch(territorio, codEspecial)),
    actualizarTotalesCabecera: (param) =>
      dispatch(FetchTotalesCabeceraCotizadores(param)),
    listarRecompra: (idPoliza, plan, suma, datosAccesorios) => dispatch(FetchDataRecompraPaquete(idPoliza, plan, suma, datosAccesorios)),
    suscripcionP2P: (datos) => dispatch(suscripcionExternaTarjetaP2P(datos)),
    consultarFv: (data) => dispatch(consultarUsuarioFV(data))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReCompra)
);
